import axios from 'axios';
import AuthService from './auth';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import httpClient from "./httpClient";

class BaseService {
	constructor() {
		this.endPoint = '';
		this.setBaseUrl();
	}

	setBaseUrl() {
    this.http = httpClient
		// this.http = axios.create({
		// 	baseURL: process.env.VUE_APP_ENDPOINT_API_URL
    // });
    // check if response http is 401 (unauthenticated)
  //   this.http.interceptors.response.use((response) => {
      
  //     return response
  //   },(error) => {
  //     if(error.response.status === 401){
  //       AuthService.logOut();
  //     }
  //     return Promise.reject(error);
  //   })
	}


	includeDefault(options) {
		let access_token = window.localStorage.getItem('access_token')
			? window.localStorage.getItem('access_token')
			: null;

		const defaultData = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + access_token
			}
		};
		return Object.assign(defaultData, options);
	}

	get(options = {}) {
		const opts = this.includeDefault(options);

		return this.http.get(this.endPoint, opts);
	}

	post(data, options = {}) {
		const opts = this.includeDefault(options);
		return this.http.post(this.endPoint, data, opts);
	}
	put(data, options = {}) {
    const opts = this.includeDefault(options);

		return this.http.put(this.endPoint, data,opts);
	}
	putOne(id, data, options = {}) {
    const opts = this.includeDefault(options);
		return this.http.put(this.endPoint + '/' + id, data, opts);
	}
	delete(id, options = {}) {
		const opts = this.includeDefault(options);
		return this.http.delete(this.endPoint + '/' + id, opts);
	}
}
export default BaseService;
